export default __webpack_public_path__ + "static/media/chris.aac343e3.png";